import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next"; 
import { textToKey } from "../../utils/textToKey";

interface Props {
  role: string;
  size?: "small" | "medium";
}

export default function UserRoleChip({ role, size = "small" }: Props) {
  const { t } = useTranslation();
  const color =
    role === "admin"
      ? "error"
      : role === "accountant"
      ? "primary"
      : "default";

  const variant = role === "external" ? "outlined" : "filled";

  return (
    <Chip
      label={t(`admin:${textToKey(role)}`, { defaultValue: role })}
      size={size}
      color={color}
      variant={variant}
    />
  );
}
